import React from "react";
import EntryForm from "../components/EntryForm";
import { useAuth } from "../context/AuthContext";
import { Lock } from "lucide-react";

export default function PurchaseEntry() {
  const { user } = useAuth();
  if (user?.role === "manager") {
    return (
      <div className="card-flat p-8 text-center" data-testid="purchase-restricted">
        <Lock className="mx-auto text-gray-400 mb-3" size={32} />
        <div className="font-heading font-bold text-xl">Restricted</div>
        <p className="text-sm text-gray-600 mt-2">Purchase entries are recorded by the owner only.</p>
      </div>
    );
  }
  return (
    <div>
      <p className="small-label text-gray-500 mb-4">Record gas received from vendor. You give MT, vendor gives Filled.</p>
      <EntryForm type="purchase" />
    </div>
  );
}
